import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { optimizeImage } from '../utilities/images';
import { trackPerformanceToNR } from '../utilities/tracking';

const OptimizedImage = ({
	alt,
	className = null,
	keyVal = null,
	src,
	style = {},
	width
}) => {
	// Start with blank imageSrc, not prop.src because we never want to load
	//   the unoptimized image
	const [imageSrc, setImageSrc] = useState('');
	const [loadedWidth, setLoadedWidth] = useState(0);

	useEffect(() => {
		trackPerformanceToNR('ws-specials-image-container-starting');
	}, []);

	useEffect(() => {
		// Only load larger images if the width changes...never downgrade
		if (width > loadedWidth) {
			const optimized = optimizeImage(src, width);
			setLoadedWidth(optimized.width);
			setImageSrc(optimized.src);
		}
	}, [src, width, loadedWidth]);

	return (
		<img // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
			key={keyVal}
			className={className}
			style={style}
			alt={alt}
			onLoad={() => {
				trackPerformanceToNR('ws-specials-first-promo-img-load');
			}}
			src={imageSrc}
		/>
	);
};

OptimizedImage.propTypes = {
	alt: PropTypes.string.isRequired,
	className: PropTypes.string,
	keyVal: PropTypes.string,
	src: PropTypes.string.isRequired,
	style: PropTypes.shape({}),
	width: PropTypes.number.isRequired
};

export default OptimizedImage;
